import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { SolutionSection } from './components/SolutionSection';
import { ModulesSection } from './components/ModulesSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { BonusSection } from './components/BonusSection';
import { ReassuranceSection } from './components/ReassuranceSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <div className="min-h-screen bg-gradient-to-b from-slate-50 via-pink-50/40 to-rose-50/30 font-sans text-slate-700 selection:bg-pink-200 selection:text-pink-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <TopBanner data-id="element-2" />
      <HeroSection data-id="element-3" />
      <PainPointsSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <ModulesSection data-id="element-6" />
      <BeforeAfterSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <ReassuranceSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FooterSection data-id="element-12" />
    </div>;
}